import axios from 'axios'
import type { TFunction } from 'i18next'

export type NetworkErrorKey =
  | 'common:networkError.offline'
  | 'common:networkError.server'
  | 'common:networkError.forbidden'
  | 'common:networkError.notFound'
  | 'common:networkError.fallback'

export function getLearnerErrorKey(err: unknown): NetworkErrorKey {
  if (axios.isAxiosError(err)) {
    if (!err.response) return 'common:networkError.offline'
    const s = err.response.status
    if (s >= 500) return 'common:networkError.server'
    if (s === 401 || s === 403) return 'common:networkError.forbidden'
    if (s === 404) return 'common:networkError.notFound'
  }
  return 'common:networkError.fallback'
}

export function getLearnerErrorMessage(
  err: unknown,
  t: TFunction,
  fallbackKey?: string,
): string {
  const key = getLearnerErrorKey(err)
  if (key !== 'common:networkError.fallback') return t(key)
  return fallbackKey ? t(fallbackKey) : t('common:networkError.fallback')
}
